// These are custom field IDs
export const INTERNAL_LABELS = {
  PROFIT_CENTER: 'profit_center'
};

export const internalToExternalLabel = {
  [INTERNAL_LABELS.PROFIT_CENTER]: 'Profit Center'
};
